import React, { useRef, useState } from 'react'
import ArticlePreview from './ArticlePreview'
import { BrowserRouter } from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Mana from './Mana'
import PropTypes from 'prop-types'
import ReactDOMServer from 'react-dom/server'
import Spinner from './Spinner'
import YouTube from 'react-youtube'
import classNames from 'classnames'
import htmlReactParser from 'html-react-parser'
import reactStringReplace from 'react-string-replace'
import styles from '../styles/Description.module.scss'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Container = ({ children, wordpress }) => {
  const { dir, subpage } = useParams()
  const myRef = useRef(null)
  const [readMore, setReadMore] = useState(false)

  return (
    <div
      className={classNames(styles.container, {
        [styles.notWordpress]: !wordpress,
      })}
    >
      <Card
        className={classNames(styles.comboDescription, 'shadow-sm')}
        ref={myRef}
      >
        {dir === 'combos' && subpage && (
          <Card.Header as='h5'>Combo Explained</Card.Header>
        )}
        <Card.Body
          className={classNames(styles.description, {
            [styles.descriptionLimitHeight]: wordpress && !readMore,
          })}
        >
          {children}
        </Card.Body>
        {wordpress &&
          (readMore ? (
            <Card.Body className={styles.readMore}>
              <Button
                block
                onClick={() => {
                  const top =
                    window.pageYOffset +
                    myRef.current.getBoundingClientRect().top -
                    120
                  window.scrollTo({ top })
                  setReadMore(false)
                }}
              >
                Read less
              </Button>
            </Card.Body>
          ) : (
            <Card.Body className={styles.readMore}>
              <Button block onClick={() => setReadMore(true)}>
                Read more
              </Button>
            </Card.Body>
          ))}
      </Card>
    </div>
  )
}

Container.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  wordpress: PropTypes.bool,
}

const Description = ({ cards, children, posts, wordpress }) => {
  const { dir } = useParams()
  const { isLoading } = useSelector((state) => state.pagedata)

  // These replacements keep the description as a string
  let newChildren = React.isValidElement(children)
    ? ReactDOMServer.renderToString(<BrowserRouter>{children}</BrowserRouter>)
    : children
  newChildren = reactStringReplace(newChildren, /\{([^}]+)\}/, (match) =>
    ReactDOMServer.renderToString(
      <BrowserRouter>
        <Mana color={match} />
      </BrowserRouter>
    )
  ).join('')
  newChildren = reactStringReplace(
    newChildren,
    /\[el\]([^[]*)\[\/el\]/,
    (match) =>
      ReactDOMServer.renderToString(
        <a
          href={`/${cards[match]?.legal_commander ? 'commanders' : 'cards'}/${
            cards[match]?.sanitized
          }`}
        >
          {cards[match]?.name}
        </a>
      )
  ).join('')
  newChildren = reactStringReplace(
    newChildren,
    /(https:\/\/edhrec\.com\/articles\/[^/]*\/)/,
    (match) => {
      if (posts && Object.keys(posts)?.includes(match)) {
        return null
      }
    }
  ).join('')

  // These replacements turn description into an array of strings and elements
  // ReactDOMServer doesn't work with elements that have state :(((
  if (newChildren.trim() === '') {
    newChildren = []
  } else {
    newChildren = [newChildren]
  }
  newChildren = newChildren
    .map((child) =>
      reactStringReplace(
        child,
        /https:\/\/www.youtube.com\/watch\?v=/,
        (match) => <YouTube videoId={match} />
      )
    )
    .flat()

  if (newChildren.length === 0) {
    newChildren = null
  }

  if (isLoading && !['cards', 'commanders'].includes(dir)) {
    return (
      <Container wordpress={wordpress}>
        <div className={styles.spinner}>
          <Spinner className='fa-3x' />
        </div>
      </Container>
    )
  } else if (!children) {
    return null
  } else {
    return (
      <>
        <div className={styles.articlesContainer}>
          {posts &&
            Object.values(posts)?.map((post) => (
              <span key={post.url} style={{ maxWidth: 600 }}>
                <ArticlePreview {...post} />
              </span>
            ))}
        </div>
        {newChildren && (
          <Container wordpress={wordpress}>
            {newChildren.map((child) =>
              React.isValidElement(child) ? child : htmlReactParser(child)
            )}
          </Container>
        )}
      </>
    )
  }
}

Description.propTypes = {
  children: PropTypes.string,
}

export default Description
